module.exports = __webpack_public_path__ + "img/baojing.6fd3c612.svg";